export default {
	back_to_top: '回到頂部',
	banner_btn: {
		buy_now: '立即購買',
		learn_more: '瞭解更多',
	},
	banner_list: [
		{
			title: '安全穩定 · 卓越性價比 · 全球網路的物理伺服器',
			subtitle: '獨立物理伺服器',
			desc: '物理伺服器以獨享硬體、高效能可客製化、強隔離安全性，為多種業務情境提供企業級算力支援<br />助力業務穩健運行與持續成長',
		},
		{
			title: 'NVMe 極速 I/O · 新一代 高效能 VPS',
			subtitle: 'NVMe 雲伺服器',
			desc: '基於最新一代 INTEL Xeon 處理器，您無需為硬體的購買和維護投入精力<br />即購買、即開通、即使用，快速部署應用',
		},
	],
	data_center: {
		desc: '覆蓋亞洲、北美、歐洲等核心資料中心，與多家 Tier 1 級國際營運商直連，TB 級中國營運商 3C 專線資源，支援 CN2/GIA。',
		list: [
			{ key: 'hk', name: '香港' },
			{ key: 'us', name: '美國' },
			{ key: 'jp', name: '日本' },
			{ key: 'kr', name: '韓國' },
			{ key: 'my', name: '馬來西亞' },
			{ key: 'sg', name: '新加坡' },
			{ key: 'au', name: '澳大利亞' },
		],
		title: '資料中心位置',
	},
	product: {
		desc: '基於新一代雲端運算架構打造的高性價比 VPS，帶來更快、更穩、更靈活的效能體驗 \n 讓您的專案全面加速',
		specialties: [
			{ title: '視覺化管理平台', desc: '為您提供智慧控制中心對雲伺服器進行管理。您可對雲伺服器進行開機、關機、重設密碼、重灌系統等操作' },
			{ title: '更高的速度', desc: '純 U.2 NVMe 架構單盤容量高達 8000G，IOPS/磁碟高達 641,800，吞吐量/磁碟高達 3200MBps，時延低至 11（µs）' },
			{
				title: '全球多網路線路',
				desc: '網路接入中國電信、移動、聯通，PCCW、香港寬頻、NTT、Cogent、Level3、Lumen 等，提供使用者自訂 VPC 組網安全隔離',
			},
		],
		title: 'NVMe 極速 I/O · 新一代 高效能 VPS ',
	},
	products: {
		desc: '我們提供多種伺服器產品，包括 VPS 主機和伺服器租用，滿足您的不同需求',
		list: [
			{ title: 'VPS 主機', desc: '高速穩定高彈性的運算服務，採用 NVMe 架構輕鬆雲端取得和啟用，實現您的運算' },
			{ title: '伺服器租用', desc: '伺服器租用採用高規格硬體確保穩定性和高效能，平台全自動化，一鍵重啟、重灌等助力核心業務飛速成長。' },
		],
		title: '多種伺服器產品',
	},
	stats: {
		data_centers: '資料中心',
		support: '客戶支援',
		uptime: '線上率',
		virtualization: '虛擬化',
	},
	testimonials: {
		desc: '我們用心收集每一位使用者提交的意見或建議。',
		title: '我們的客戶評價',
	},
	testimonials_list: [
		{ quote: '彈性雲自主配置資源，不再浪費多餘的錢，而且還有機齡計畫，越用越開心。', name: 'Jerry Liu' },
		{ quote: '對資源自動監控，控制濫用使用者，保障網路連線不卡頓，硬碟不變石頭，值得推薦。', name: '阿粉' },
		{ quote: '雲伺服器擁有強大的自訂面板，線上操作，方便快捷，一觸即達；價格實惠，效能優越，是雲伺服器的不錯選擇。', name: '夢い' },
	],
	why: {
		desc: '我們 2012 年開始涉足虛擬主機，2014 年涉足雲伺服器，於 2019 年成立新品牌，全線雲伺服器產品均採用成熟的 KVM 虛擬化技術，配合自主研發的繁體中文易操作控制面板，能為您提供成熟的雲伺服器產品，高可用的自主管理。',
		list: [
			{
				title: '擔心資源不夠用？',
				desc: '業務剛起步，服務商就說 IP 不夠了；旺季流量漲了，頻寬跟不上；被迫遷移伺服器，損失慘重',
				solution: '解決方案：百萬 IP ＋ TB 級頻寬，站群 IP 80 美元/月起',
				case: '從 1 台到 1000 台，我們都能接住',
			},
			{
				title: '擔心出問題沒人管？',
				desc: '半夜伺服器掛了，客服讓你發英文郵件；技術問題說不清，溝通成本太高；找不到人，只能乾著急',
				solution: '解決方案：7×24 中文客服，15 分鐘響應緊急故障',
				case: '母語溝通，零障礙服務',
			},
			{
				title: '擔心技術門檻高？',
				desc: '買了伺服器不會設定環境；裝個 WordPress 都要折騰半天；想專心做業務，不想學 Linux 指令',
				solution: '解決方案：一鍵部署，3 分鐘上線應用',
				case: '對比：傳統幾小時 → 我們 3-5 分鐘',
			},
		],
		title: '為什麼選擇我們',
	},
}
